import pinCode from "../components/MainComponents/pinCodePad.vue";
import { FirebaseSingleton } from "./firebaseSingleton.js";
import Vue from "vue";
import _ from "lodash";
import moment from "moment";

//

//const dbasesHelper   = database()
export default class UVHelper {
  constructor(Vue) {
    if (Vue) {
      this.vue = Vue;
    }
  }
  log(data, priority) {
    let useConsole = true;
    let printOnlyPriority = true;
    if (useConsole) {
      if (printOnlyPriority) {
        if (priority) {
          console.log(data);
        }
      } else {
        console.log(data);
      }
    }
  }
  getDate(date = null, format = null) {
    let f = date ? (format ? moment(date, format) : moment(date)) : moment();
    return f;
  }
  invertColor(hex, bw = true) {
    try {
      if (hex.indexOf('#') === 0) {
        hex = hex.slice(1);
      }
      // convert 3-digit hex to 6-digits.
      if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }

      var r = parseInt(hex.slice(0, 2), 16),
        g = parseInt(hex.slice(2, 4), 16),
        b = parseInt(hex.slice(4, 6), 16);
      if (bw) {
        // https://stackoverflow.com/a/3943023/112731
        return (r * 0.299 + g * 0.587 + b * 0.114) > 186
          ? '#000000'
          : '#FFFFFF';
      }
      // invert color components
      r = (255 - r).toString(16);
      g = (255 - g).toString(16);
      b = (255 - b).toString(16);
      // pad each with zeros and return
      return "#" + this.padZero(r) + this.padZero(g) + this.padZero(b);
    } catch (e) {
      return '#FFFFFF';
    }
  }
  checkVirtualKeyBoard(entorno) {
    let actualOption = localStorage.getItem("useVirtualKeyboard");
    actualOption = actualOption == "true";
    if (actualOption) {
      entorno.$uvVirtualKeyboard.init(() => {
        //this.$forceUpdate()
      });
    }
  }
  test() {
    alert("helper funcionando");
  }
  rand() {
    return Math.random().toString(36).substr(2);
  }
  token() {
    return this.rand() + this.rand();
  }
  getById(data, prop, code) {
    let data_fileter = {};
    data_fileter[prop] = code;
    let itemIndex = _.findIndex(data, data_fileter);
    if (itemIndex >= 0) {
      data[itemIndex].idx = itemIndex;
      return data[itemIndex];
    }

    return false;
  }
  writeConfigFile(idCaja, modulo) {
    var obj = {
      caja_id: idCaja,
      modulo: modulo,
    };
    var json = JSON.stringify(obj);
    var fs = require("fs");
    fs.writeFile("configCaja.json", json, "utf8", () => { });
  }
  getPDVDepartamento(vue) {
    let config = this.readConfig();
    let departamento = this.getById(
      vue.$store.getters.getPDVDepartamentos,
      "id",
      config.modulo
    );
    return departamento;
  }
  restaurarCaja() {
    var obj = {};
    var json = JSON.stringify(obj);
    var fs = require("fs");
    fs.writeFile("configCaja.json", json, "utf8", () => { });
  }
  readConfig() {
    var fs = require("fs");
    try {
      const json = fs.readFileSync("configCaja.json", "utf8");
      let obj = JSON.parse(json);

      return obj;
    } catch (err) {
      var obj = {};
      var json = JSON.stringify(obj);

      fs.writeFile("configCaja.json", json, "utf8", () => { });
      return obj;
    }
  }
  formatNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }

  checkLimitCaja(limit, vue, confirmCallback) {
    let caja = JSON.parse(localStorage.getItem("caja"));
    if (!caja) {
      caja = { open: false };
    } else {
      if (caja.totalVentas - caja.totalRetiros > limit) {
        vue
          .$swal({
            icon: "warning",
            title: "Se alcanzo el limite de efectivo permitido en la caja",
            text: "",
            confirmButtonText: "Realizar un retiro",
            cancelButtonText: "Continuar sin retirar",
            showCancelButton: true,
          })
          .then((result) => {
            if (result.value) {
              confirmCallback();
            }
          });
        return false;
      }
    }
  }
  async requireAdminPass(vue, departamento, confirmCallback) {
    vue
      .$swal({
        title: "Contraseña Administrador",
        input: "password",
        inputAttributes: {
          autocapitalize: "off",
        },
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        showLoaderOnConfirm: true,
        preConfirm: async (code) => {
          const fSingleton = await FirebaseSingleton.init();
          let filter = departamento + "~~" + code;
          let dataValue = await fSingleton.database
            .ref("PDV/Administradores")
            .orderByChild("ACCS~~CONT/" + filter)
            .equalTo(true)
            .once("value");
          if (dataValue.exists()) {
            return { ok: true };
          } else {
            return { ok: false };
          }
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
      })
      .then((result) => {
        if (result.dismiss) {
          return false;
        }

        if (result.value.ok == true) {
          confirmCallback();
        } else {
          vue.$swal({
            icon: "error",
            title: "Clave incorrecta",
            text: "Proporcione una clave valida para administrador",
          });
          return false;
        }
      });
  }
  onlyNumber($event, value) {
    value = value.toString();
    // console.log($event.keyCode); //keyCodes value
    let keyCode = $event.keyCode ? $event.keyCode : $event.which;

    // only allow number and one dot
    if (
      (keyCode < 48 || keyCode > 57) &&
      (keyCode !== 46 || value.indexOf(".") != -1)
    ) {
      // 46 is dot
      $event.preventDefault();
    }
    if (value != 0) {
      // restrict to 2 decimal places
      if (
        value != null &&
        value.indexOf(".") > -1 &&
        value.split(".")[1].length > 1
      ) {
        $event.preventDefault();
      }
    }
  }
  inactivityTime(entorno) {
    var time;
    var ComponentClass = Vue.extend(pinCode);
    var instance = new ComponentClass({ propsData: { mode: "requestCode" } });

    window.onload = resetTimer;
    // DOM Events
    document.onmousemove = resetTimer;
    document.onmousedown = resetTimer; // touchscreen presses
    document.ontouchstart = resetTimer;
    document.onclick = resetTimer; // touchpad clicks
    document.onkeydown = resetTimer; // onkeypress is deprectaed
    document.addEventListener("scroll", resetTimer, true);

    function logout() {
      instance.$mount(); // pass nothing

      entorno.pinCodeRequest();
      //entorno.$refs.dashContainer.appendChild(instance.$el)
      //alert("inactividad detectada.")
      //location.href = 'logout.html'
    }

    function resetTimer() {
      clearTimeout(time);
      time = setTimeout(logout, 600000);
      // 1000 milliseconds = 1 second
    }
  }
  verifyPermissions(action, permissions) {
    if (permissions[action]) {
      return true;
    } else {
      return false;
    }
  }
  getDayName(numberDay, mode) {
    let days = ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"];
    let daysCompletName = [
      "Domingo",
      "Lunes",
      "Martes",
      "Miercoles",
      "Jueves",
      "Viernes",
      "Sabado",
    ];
    if (mode == "Simple") {
      return days[numberDay];
    } else {
      return daysCompletName[numberDay];
    }
  }
  uiConfig() {
    return {
      mainColor: "light-blue darken-4",
      appName: "ParGolfSolutions",
    };
  }
}
